import RootState from '@/store/root_state';
import { ActionTree } from 'vuex';
import { DocumentsState } from './state';
import SentryClient from '@/helpers/sentry';
import { UserEnrollmentsService } from '@/services/undergrad/pegasus-epona/user-enrollments.service';

const actions: ActionTree<DocumentsState, RootState> = {
  async PULL_USER_PENDING_DOCS({ commit }, currentCourseId: string): Promise<void> {
    try {
      commit('SET_IS_LOADING_REQUIRED_DOCS', true);
      const response = await UserEnrollmentsService.getUserPendingDocs();

      const pendingDocsByCourseId = response.find(({ courseId }) => courseId === currentCourseId);

      if (!pendingDocsByCourseId) throw new Error('Could not find course on response.');

      commit('SET_SENT_ALL_REQUIRED_DOCS', pendingDocsByCourseId.lyceumPendingDocs.length === 0);
    } catch (error) {
      SentryClient.captureError(error);
    } finally {
      commit('SET_IS_LOADING_REQUIRED_DOCS', false);
    }
  },
};

export default actions;
